import PropTypes from 'prop-types'
import React from 'react'
import Base from '../../containers/BaseContainer'
import classNames from 'classnames'

import styles from './Toggle.module.scss'

class Toggle extends Base {

  constructor (props) {
    super(props)
    this._bind('_handleChangeChk')
    this.state = {
      toggle: this.props.toggleInitState || false}
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.type === 'check' && nextProps.toggleInitState) {
      this.setState({toggle: nextProps.toggleInitState})
    }
  }

_handleChangeChk (event) {
  let valueChecked = event.currentTarget.value
  if (this.props.type === 'check') valueChecked = event.currentTarget.checked
  // console.log('check change : ' + event.currentTarget.value)
  this.setState({
    toggle: valueChecked, // !this.state.toggle, // flip boolean value
  })
  this.props.toggleChanged(event, this.props.position, valueChecked)
}

render () {
  let value = this.state.toggle// ?true:false
  // console.log('toggle pos:' + this.props.position + ' initstate:' + value + ' toggleInitState:' +
  // this.props.toggleInitState)

  let toggleClassList = classNames(styles.toggle,
    this.props.classNames ? styles[this.props.classNames] : null)

  return (
			<label className={toggleClassList} title={this.props.title}>
        {this.props.type === 'check'
          ? <input type='checkbox' name={this.props.name ? this.props.name : 'menu_type'}
                   checked={this.props.toggleInitState}
            tabIndex='-1' disabled={this.props.disabled}
            onChange={this._handleChangeChk} />
          : <input type='radio' name='menu_type' defaultChecked={value}
            tabIndex='-1' disabled={this.props.disabled}
            onChange={this._handleChangeChk} />
        }
        <div className={styles.slider}></div>
      </label>
		)
	}
}

Toggle.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  toggleInitState: PropTypes.bool,
  toggleChanged: PropTypes.func.isRequired,
  position: PropTypes.number.isRequired,
  classNames: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
}

export default Toggle

/*  */
